import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { GoalI } from 'src/app/services/goal/goal.service';

@Component({
  selector: 'app-goal-card',
  templateUrl: './goal-card.component.html',
  styleUrls: ['./goal-card.component.css'],
})
export class GoalCardComponent {
  constructor(private readonly auth: AuthLoginService) {}

  @Input() title!: string;

  @Input() date1: Date | undefined;
  dateString1!: string;
  @Input() description1: string | undefined;
  @Input() id1!: number;

  @Input() date2: Date | undefined;
  dateString2!: string;
  @Input() description2: string | undefined;
  @Input() id2!: number;

  presentModal() {
    if (this.date1)
      this.dateString1 = formatDate(this.date1!, 'dd/MM/yyyy', 'en-US');
    if (this.date2)
      this.dateString2 = formatDate(this.date2!, 'dd/MM/yyyy', 'en-US');
    this.visible = true;
  }
  hoy = new Date();
  @Output() buttonClick = new EventEmitter<GoalI[]>();

  /** @description retorna los objetos */
  async onButtonClick() {
    this.date1 = new Date(this.dateString1);
    this.date2 = new Date(this.dateString2);

    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;
    const { user } = userState;

    this.buttonClick.emit([
      {
        init_date: this.date1,
        description: this.description1!,
        position: this.id1,
        upload_user: user?.id!,
      },
      {
        init_date: this.date2,
        description: this.description2!,
        position: this.id2,
        upload_user: user?.id!,
      },
    ]);
    this.visible = false;
  }

  /** @description Calcula los días desde x hasta hoy */
  returnDays(date: Date) {
    if (date) {
      const initDate = new Date(date);
      const today = new Date();
      const dif = today.getTime() - initDate.getTime();
      return Math.floor(dif / (1000 * 60 * 60 * 24));
    } else return 0;
  }

  visible = false;
}
